// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"6aa5ad27","119":"209899c2","252":"ed13defd","313":"f50794cb","328":"0c5ff02c","462":"519413ad","584":"2facc906","784":"2c5a592b","883":"4f4b3ee4","905":"04a3d68c","906":"4a882e0c","996":"3039075f"}[chunkId] + ".chunk.js";
};